import { Link } from "react-router-dom";

// Pill CTA. `to` for router links, `href` for external/tel.
export default function Cta({ children, to, href, variant = "primary", className = "", ...props }) {
  const base =
    "inline-flex items-center justify-center gap-2 font-display font-bold uppercase tracking-widest text-sm px-7 py-3.5 rounded-full btn-glow";
  const variants = {
    primary: "bg-cyan-500 text-ink-950 hover:bg-cyan-400",
    secondary: "border border-white/20 text-white hover:border-cyan-500 hover:text-cyan-400",
    ghost: "text-cyan-400 hover:text-white",
  };
  const cls = `${base} ${variants[variant]} ${className}`;
  if (to) return (<Link to={to} className={cls} {...props}>{children}</Link>);
  return (<a href={href} className={cls} {...props}>{children}</a>);
}
